module.exports = __webpack_public_path__ + "img/1.ab83609f.jpg";